export default __webpack_public_path__ + "static/media/guest_09_1_sheynna.caba5847.png";